"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Inbox = _interopRequireDefault(require("@material-ui/icons/Inbox"));

var _Drafts = _interopRequireDefault(require("@material-ui/icons/Drafts"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      maxWidth: 360,
      width: '100%'
    },
    currentItem: {
      background: theme.palette.secondary.main,
      color: theme.palette.primary.main,
      transition: theme.transitions.create(['background', 'color', 'opacity'], {
        duration: theme.transitions.duration.complex
      }),
      '&:hover': {
        background: theme.palette.secondary.main
      }
    },
    list: {
      padding: 0
    },
    listItem: {
      color: theme.palette.primary.contrastText,
      '&:hover': {
        background: theme.palette.primary.dark
      }
    },
    listItemIcon: {
      align: 'center',
      color: 'inherit'
    },
    listItemText: {
      color: 'inherit',
      fontSize: '0.875rem',
      fontWeight: 'bold',
      padding: 0
    }
  };
};

var MenuItems =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItems, _React$Component);

  function MenuItems(props) {
    var _this;

    _classCallCheck(this, MenuItems);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItems).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (path) {
      _this.setState(function () {
        return {
          currentPath: path
        };
      });

      _this.props.handleItemClick(path);
    });

    _this.state = {
      currentPath: props.currentPath
    };
    return _this;
  }

  _createClass(MenuItems, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;
      var currentPath = this.state.currentPath;
      var array = [];
      var items = this.props.items || [];
      items.map(function (item, i) {
        array.push(_react["default"].createElement("div", {
          key: i
        }, _react["default"].createElement(_ListItem["default"], {
          className: currentPath === item.path ? classes.currentItem : classes.listItem,
          button: true,
          onClick: function onClick() {
            return _this2.handleItemClick(item.path);
          }
        }, _react["default"].createElement(_ListItemIcon["default"], {
          className: classes.listItemIcon
        }, _react["default"].cloneElement(item.icon, {
          color: "inherit",
          fontSize: "small"
        })), _react["default"].createElement(_ListItemText["default"], {
          classes: {
            primary: classes.listItemText,
            root: classes.listItemText
          },
          primary: item.label
        }))));
      });
      return _react["default"].createElement("div", {
        className: classes.root
      }, _react["default"].createElement(_List["default"], {
        component: "nav",
        className: classes.list
      }, array));
    }
  }]);

  return MenuItems;
}(_react["default"].Component);

MenuItems.propTypes = {
  classes: _propTypes["default"].object.isRequired
};

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(MenuItems);

exports["default"] = _default;